export enum CommonQuestionKeys {
  ADDRESS = 'address.address',
  ADMIN_ONLY = 'adminOnly',
  AFFIRMATION = 'affirmation',
  AGE = 'age',
  APPLICATION_ASSISTANCE_HELPER = 'submission.assistance.helper',
  DATE_OF_BIRTH = 'dateOfBirth',
  DEMOGRAPHICS = 'demographics',
  DISABLED = 'disabled',
  EMAIL = 'email',
  EMPLOYER_ADDRESS = 'employerAddress',
  ENGLISH = 'english',
  ETHNICITY = 'ethnicity',
  GENDER = 'gender',
  HOUSEHOLD_INCOME = 'householdIncome',
  HOUSEHOLD_MEMBERS = 'householdMembers',
  HOUSEHOLD_SIZE = 'householdSize',
  HOUSING_TYPE = 'housingType',
  JOB_TITLE = 'jobTitle',
  LANGUAGE = 'language',
  MAILING_ADDRESS = 'address.mailingAddress',
  MARITAL_STATUS = 'maritalStatus',
  PHONE_NUMBER = 'phoneNumber',
  PREFERRED_PAYMENT_METHOD = 'preferredPaymentMethod',
  RACE = 'race',
  SIGNATURE = 'submission.signature',
  VETERAN = 'veteran',
  ZIP_CODE = 'zipCode',
}
